import type { TFunction } from 'i18next';

import { REQUEST_KIND_LABEL_KEY } from './requestLabels';

/**
 * A request's kind, as a person reads it — falling back to the raw template
 * code when there is no label for it.
 *
 * THE FALLBACK IS THE POINT. `kind` is the code of whatever template the
 * request's first message used (spec D-3), and migrated rows carry legacy
 * types that were never seeded. An unlabelled kind must still show something a
 * human can act on; an empty cell would hide the row's whole subject.
 *
 * `null` in, `null` out: a request with no messages at all has no kind, and
 * the caller decides what to render for that.
 */
export function kindLabel(kind: string | null, t: TFunction): string | null {
  if (kind === null) return null;

  /*
   * `in` rather than an index-then-check: `as const` on the map makes its
   * values the literal key union the typed `t()` accepts, and narrowing
   * through `in` is what keeps that literal type instead of widening it to
   * `string` — which `t()` rejects, by design (see `requestLabels.ts`).
   */
  if (kind in REQUEST_KIND_LABEL_KEY) {
    return t(REQUEST_KIND_LABEL_KEY[kind as keyof typeof REQUEST_KIND_LABEL_KEY]);
  }

  return kind;
}
